webpackJsonp([225211428462577],{

/***/ 1251:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"IguanaRisOrderUpdateStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"COMPLETED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"INPROGRESS"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-iguana-ris-order-update-status-6782769d2f33d17afa13.js